// extracted by mini-css-extract-plugin
module.exports = {"brandBar":"index_brandBar_1PBwr"};